export default __webpack_public_path__ + "static/media/php.4ba17fd0.png";